import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { Container, Alert, AlertTitle } from '@mui/material'

import useAuth from 'src/hooks/useAuth'

type RoleBasedGuardProps = {
  requiredRoles: string[]
  children: ReactNode
}

export default function RoleBasedGuard({
  requiredRoles,
  children
}: RoleBasedGuardProps) {
  const { user } = useAuth()

  const currentRole = user?.role as string | undefined

  if (!currentRole || !requiredRoles.includes(currentRole)) {
    return (
      <Container sx={{ py: 10 }}>
        <Alert severity="error">
          <AlertTitle>Permission Denied</AlertTitle>
          You do not have permission to access this page.
        </Alert>
      </Container>
    )
  }

  return <>{children}</>
}
